import {Backdrop, makeStyles} from "@material-ui/core";
import clsx from 'clsx';
import {
  getBraintrustList,
  moveNextPage,
  updateAsyncThumbnailImg,
  updateUserMetrics,
  validateSessionCode
} from "../../../../../store/actions/creator/creatorExperienceBuilder";
import {useDispatch, useSelector} from "react-redux";
import {apiClient} from "../../../../../config/apiClient";
import {useEffect, useState} from "react";
import {YOUTUBE_DATA} from "../../../../../config/mock";
import {handleCopyFile} from "../../../../../helper/stimulus";
import UtilService from "../../../../../helper/service";
import {useHistory, useLocation} from "react-router";
import { Loading } from "../../../../atoms/commonLoadings";

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  chooseSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    width: '100%',
    minWidth: 742
  },
  myOwn: {
    width: 400,
    height: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    marginRight: 50
  },
  pieces: {
    width: 400,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginLeft: 50
  },
  img: {
    width: 140,
    height: 80,
    borderRadius: 10,
    objectFit: 'cover'
  },
  checkTitle: {
    fontFamily: 'roboto-bold',
    fontSize: 20,
    color: '#212D40',
    position: 'absolute',
    bottom: 30
  },
  eachYoutube: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    cursor: 'pointer',
    flex: 1,
    maxWidth: 'calc(50% - 20px)',
    margin: '0 10px'
  },
  youtubeTitle: {
    fontFamily: 'roboto-bold',
    fontSize: 14,
    color: '#212D40',
    paddingTop: 10,
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'center'
  },
  duration: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#8091A1'
  },
  pb20: {
    paddingBottom: 18
  },
  youtubeHover: {
    transform: "scale3d(1.05, 1.05, 1)",
    boxShadow: '20px 20px 15px rgba(0, 0, 0, 0.5), 5px 5px 5px rgba(0, 0, 0, 0.5)'
  }
}));

// for trial First Time experience builder
function TrialGreatChoice() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [hoverIndex, setHoverIndex] = useState(-1);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const {braintrustList} = useSelector((state: any) => state.experience);
  const [selectExperiences, setSelectExperiences] = useState(YOUTUBE_DATA);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";

  useEffect(() => {
    if (history.location.hash !== '#async0') {
      UtilService.addHashTag(history, location.pathname, 'async0');
    }
    dispatch(getBraintrustList(apolloClient.client))
  }, []);

  useEffect(() => {
    if (braintrustList && braintrustList.length > 0) {
      setSelectExperiences(UtilService.getPredefinedExperiences(braintrustList))
    }
  }, [braintrustList]);

  const handleMyOwn = () => {
    dispatch(updateUserMetrics('myOwn', true));
    dispatch(updateUserMetrics('asyncVideoUrl', ''));
    dispatch(updateUserMetrics('asyncExperienceName', ''));
    dispatch(updateUserMetrics('streamType', ''));
    dispatch(updateAsyncThumbnailImg(null));
  };

  const goInvitePage = async (item: any) => {
    const fetchedSessionCode = await getSessionCode();
    if (fetchedSessionCode) {
      dispatch(updateUserMetrics('sessionCode', fetchedSessionCode));
      if (item.braintrust_id) {
        const payload = {
          source_session_code: item.session_code,
          source_tenant_id: item.customer_id,
          target_session_code: fetchedSessionCode,
          target_tenant_id: loginUserData.customer_id,
          created_by: loginUserData.username
        };
        await apiClient(true).post('/stimulus/v2/stimulus/copy', payload);
        dispatch(updateUserMetrics('braintrust', item));
        const startDate = UtilService.getAsyncAddminuite();
        dispatch(updateUserMetrics('asyncStartDateTime', startDate));
        if (item.session_started_at && item.session_ended_at) {
          const diffrence = parseInt(item.session_ended_at) - parseInt(item.session_started_at);
          dispatch(updateUserMetrics('asyncEndDateTime', UtilService.getDateAddseconds(startDate, diffrence)))
        } else {
          dispatch(updateUserMetrics('asyncEndDateTime', UtilService.getXHoursAboveDateTime(startDate, 24)))
        }
      } else {
        await uploadFile(fetchedSessionCode, item);
        dispatch(updateUserMetrics('braintrust', null));
        dispatch(updateUserMetrics('asyncStartDateTime', UtilService.getXHoursAboveDateTime(new Date(), 1 / 60)))
      }
    }
    if (item.streamType === "VDO") {
      dispatch(updateUserMetrics('isLink', false));
      dispatch(updateUserMetrics('copyExperience', item));
      dispatch(updateUserMetrics('asyncFile', " "));
      dispatch(updateUserMetrics('asyncFileName', item.url ? item.url.split("/").pop() : ""));
    } else {
      dispatch(updateUserMetrics('isLink', true));
      dispatch(updateUserMetrics('asyncVideoUrl', item.url));
    }
    dispatch(updateUserMetrics('content', item.category));
    dispatch(updateUserMetrics('item', item.subcategory));
    dispatch(updateUserMetrics('myOwn', false));
    dispatch(updateUserMetrics('streamType', item.streamType));
    dispatch(updateUserMetrics('asyncExperienceName', item.title));
    // go to invite page
    dispatch(updateUserMetrics('path', 1));
    dispatch(moveNextPage(4))
  };

  const uploadFile = async (sCode: string, item: any) => {
    const payload = {
      file: item.streamType && item.streamType === "VDO" ? " " : null,
      fileName: '',
      streamType: item.streamType,
      stimulusType: item.stimulusType,
      sessionCode: sCode,
      sortOrder: "1",
      tenantId: loginUserData.customer_id,
      stimulusAlias: item.title,
      stimulusDescription: item.url,
      operation: item.streamType && item.streamType === "VDO" ? "COPY" : "",
      sourceId: item.sourceId && item.streamType && item.streamType === "VDO" ? item.sourceId : ""
    };
    setLoading(true);
    try {
      const res: any = await handleCopyFile(payload);
      if (res && res.key) {
        dispatch(updateUserMetrics('linkUploaded', true));
        dispatch(updateUserMetrics('fileUploaded', false));
        dispatch(updateUserMetrics('asyncFileName', ''));
        dispatch(updateUserMetrics('asyncFile', null));
      } else {
        dispatch(updateUserMetrics('linkUploaded', false));
        dispatch(updateUserMetrics('fileUploaded', false));
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const getSessionCode = async () => {
    const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
    const payload = {
      "requestor": "experience",
      "tenant_id": loginUserData.customer_id
    };
    setLoading(true);
    try {
      const res = await apiClient(false).post('/registration/v2/session/tokens', payload);
      if (res && res.data && res.data.token) {
        const checkSession = await validateSessionCode(apolloClient.client, res.data.token);
        if (checkSession && checkSession.data && checkSession.data.validateSessionCode) {
          localStorage.setItem("session_code", String(res.data.token));
          return res.data.token;
        } else {
          getSessionCode();  
        }
      } else {
        getSessionCode();
      }
    } catch (e) {
      return '';
    }
    return '';
  };

  return (
    <div className={classes.root}>
      <div className="loader">
        <Backdrop open={loading} >
          <Loading />
        </Backdrop>
      </div>
      <p className={"creator-title"} >
        Great choice.
      </p>
      <p className='creator-main-title'>
        Measure your own content or pick from one of our sample pieces.
      </p>
      {braintrustList ? 
        <div className={classes.chooseSection}>
          <div className={classes.myOwn}>
            <img
              style={{ position: 'absolute', top: 0 }}
              alt="img"
              src={'/assets/icons/pre-recorded2.svg'}
              onClick={() => handleMyOwn()}
              onMouseOver={e => (e.currentTarget.src = "/assets/icons/pre-recorded.svg")}
              onMouseOut={e => e.currentTarget.src = "/assets/icons/pre-recorded2.svg"}
            />
            <span className={classes.checkTitle}>My own</span>
          </div>
          <div className={classes.pieces}>
            {
            selectExperiences.map((item: any, index: number) => (
                <div
                  className={clsx(classes.eachYoutube, classes.pb20)}
                  key={index}
                  onClick={() => goInvitePage(item)}
                  onMouseOver={() => setHoverIndex(index)}
                  onMouseOut={() => setHoverIndex(-1)}
                >
                  <img
                    className={hoverIndex === index ? clsx(classes.img, classes.youtubeHover) : classes.img}
                    src={item.thumbnail}
                    alt={'img'}
                  />
                  <span className={classes.youtubeTitle}>{item.title}</span>
                  <span className={classes.duration}>{UtilService.getExperienceLength(item.duration)}</span>
                </div>
              ))
            }
          </div>
        </div> : <Loading />
        }
    </div>
  )
}

export default TrialGreatChoice;